import { useNavigate } from 'react-router-dom';

import { BackdropDialog } from '../../../../components/shared/backdrop/BackdropDialog';
import { useCreateMultipleChoiceAssessmentAttempt } from '../../api/useMultipleChoiceAssessments';
import { useAttemptMode } from '../../useAttemptMode';
import { MultipleChoiceAssessmentAttempt } from '../multiple-choice-assessment-attempt/MultipleChoiceAssessmentAttempt';

type ContainerProps = {
  subjectId: string;
  /** The assessment being sat, or undefined with the dialog closed. */
  assessmentId?: string;
  onClose: () => void;
};

/**
 * Sits an assessment in a dialog and, once it is submitted, sends the user to its
 * results. The attempt stays mounted through the closing fade, which is why the id
 * is only read while the dialog is open.
 */
function MultipleChoiceAssessmentAttemptDialog({
  subjectId,
  assessmentId,
  onClose,
}: ContainerProps) {
  const navigate = useNavigate();

  const attemptMode = useAttemptMode(subjectId);

  const { mutateAsync: createMultipleChoiceAssessmentAttempt } =
    useCreateMultipleChoiceAssessmentAttempt();

  return (
    <BackdropDialog open={assessmentId !== undefined}>
      <MultipleChoiceAssessmentAttempt
        mode={attemptMode}
        onStart={(mode) =>
          createMultipleChoiceAssessmentAttempt({
            subjectId,
            assessmentId: assessmentId!,
            mode,
          })
        }
        onFinish={(attempt) => {
          onClose();
          navigate(
            `/materia/${subjectId}/simulacros/mc/resultados/${attempt.id}`,
          );
        }}
        onClose={onClose}
      />
    </BackdropDialog>
  );
}

export { MultipleChoiceAssessmentAttemptDialog };
